import React, { Component } from 'react'
import Predefine_ColarFull_Soccer from '../components/Predefine_ColarFull_Soccer/Predefine_ColarFull_Soccer'

export class Predefine_ColarFull_SoccerPage extends Component {
  render() {
    return (
     <Predefine_ColarFull_Soccer/>
    )
  }
}

export default Predefine_ColarFull_SoccerPage